import * as dotProp from 'dot-prop-immutable';
import { Action } from 'typescript-fsa';

import { createReducer, updateArrayItemAfterAsyncCall } from '@topconagriculture/frontend-utils';

import { getRecipe } from '../recipes/recipes.actions';
import { createPremix, deletePremix, editPremix, getPremix, getPremixList } from './premixes.actions';
import { Premix } from './premixes.types';
// tslint:disable-next-line
import { Recipe } from '../recipes/recipes.types';

export type PremixState = Premix[];

const initialState: PremixState = [];

const premixesReducer = createReducer(initialState, {
  [getPremixList.done.type]: (state: PremixState, action: Action<any>) => {
    return action.payload.result
      .filter((recipe) => recipe.premix)
      .sort((elem1: Premix, elem2: Premix) => {
        return elem1.description.toLowerCase().localeCompare(elem2.description.toLowerCase());
      });
  },
  [getPremix.done.type]: (state: PremixState, action: ReturnType<typeof getPremix.done>) => {
    const newPremix = action.payload.result;
    return state.map((premix) => (premix.id === newPremix.id ? { ...premix, ...newPremix } : premix));
  },
  [getPremix.done.type]: (state: PremixState, action: Action<{ result: Premix }>) => {
    const premixDetail = action.payload.result;
    return state.map((premix: Premix) => {
      if (premix.id === premixDetail.id) {
        return {
          ...premix,
          ...premixDetail,
        };
      }
      return premix;
    });
  },
  [createPremix.done.type]: (state: PremixState, action: Action<any>) => [...state, ...[action.payload.result]],
  [editPremix.done.type]: (state: PremixState, action: Action<any>) =>
    updateArrayItemAfterAsyncCall<Premix>(state, action),
  [deletePremix.done.type]: (state: PremixState, action: Action<any>) => {
    const deletedRationId: string = action.payload.result;
    const indexFound = state.findIndex((ration: Premix) => ration.id === deletedRationId);
    return dotProp.delete(state, indexFound);
  },
  [getRecipe.done.type]: (state: PremixState, action: Action<{ result: Recipe }>) => {
    const recipeDetail = action.payload.result;
    return state.map((premix: Premix) => {
      if (premix.id === recipeDetail.id) {
        return {
          ...premix,
          ...recipeDetail,
        };
      }
      return premix;
    });
  },
});

export default premixesReducer;
